import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

(function () {
    $.ajaxPrefilter((options) => {
        if (document.location.host.indexOf('nih.gov') !== -1 || document.location.host === '156.40.214.195') {
            options.url = '/RISR/' + options.url;
        }
    });

    /**
     * copyData
     * @param {*} data
     */
    window.copyData = (data) => {
        return data ? JSON.parse(JSON.stringify(data)) : data;
    };

    // Returns the version of Internet Explorer or a -1
    // (indicating the use of another browser).
    window.ieVedr = function getInternetExplorerVersion () {
        var rv = -1, // Return value assumes failure.
            ua,
            re;

        if (navigator.appName === 'Microsoft Internet Explorer') {
            ua = navigator.userAgent;
            re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        }

        return rv;
    };

    window.isAtLeastIE11 = !!(navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/));

    if (window.ieVer > 0 || window.isAtLeastIE11) {
        window.isIE = true;
    }


    /* GET SCROLLBAR WIDTH */
    function getScrollbarWidth () {
        if (window.ieVer < 9 && window.ieVer > 0) {
            return 18;
        } else {
            var $inner = $('<div style="width: 100%; height:200px;">test</div>'),
                $outer = $('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
                inner = $inner[0],
                outer = $outer[0],
                width1,
                width2;

            $('body').append(outer);
            width1 = inner.offsetWidth;
            $outer.css('overflow', 'scroll');
            width2 = outer.clientWidth;
            $outer.remove();

            return (width1 - width2);
        }
    }

    window.calculateScrollTableHeight = function (scroll, reset) {
        var calculatedHeight,
            bodyH = $('body').height(),
            siteHeaderH = $('.site-header').outerHeight(),
            siteFooterH = $('.landing-page').hasClass('show') ? 0 : ($('#footer').outerHeight()),
            breadcrumbH = $('.breadcrumb').length > 0 ? $('.breadcrumb').outerHeight() : 0,
            landingH = $('.landing-page').hasClass('show') ? $('.landing-page').outerHeight() : 10,
            topFilterH = $('.top-filters').outerHeight(),
            floatedHeaderH = $('.floated-header').outerHeight();

        if (reset) {
            calculatedHeight = 'auto';
            scroll.height(calculatedHeight);
        } else {
            calculatedHeight = bodyH - siteHeaderH - landingH - topFilterH - breadcrumbH - siteFooterH;

            $('.app__view-wrapper').css({
                'height': calculatedHeight
            });

            scroll.height(calculatedHeight - floatedHeaderH);
        }
    };

    $.fn.floatTableColumn = function (reinit) {
        var table = $(this),
            scrollTable = $(this).closest('.table-comp__scroll'),
            thead = scrollTable.siblings('.floated-header').find('thead'),
            tbody = table.find('tbody');

        if (reinit) {
            thead.css('left', -tbody.scrollLeft());
            thead.find('th:nth-child(1)').css('left', scrollTable.scrollLeft() >= 0 ? scrollTable.scrollLeft() : 0);
            tbody.find('td:nth-child(1)').css('left', scrollTable.scrollLeft() >= 0 ? scrollTable.scrollLeft() : 0);
        }

        scrollTable.scroll(function () {
            thead.css('left', -tbody.scrollLeft());
            thead.find('th:nth-child(1)').css('left', scrollTable.scrollLeft() >= 0 ? scrollTable.scrollLeft() : 0);
            tbody.find('td:nth-child(1)').css('left', scrollTable.scrollLeft() >= 0 ? scrollTable.scrollLeft() : 0);
        });
    };

    /* float table header */
    $.fn.floatTableHeader = function (update) {
        var table = $(this),
            thead = table.children('thead'),
            th = thead.find('tr:last-child th'),
            tbody = table.children('tbody'),
            td = tbody.find('tr:first-child td'),
            // widget = table.closest('.widget'),
            scroll = table.closest('.scroll-table'),
            scrollbarWidth = getScrollbarWidth(),
            floatedBackground = table.closest('.table-comp__wrapper').siblings('.floated-background'),
            // newThead = thead.clone(true),
            offsetTop,
            floatedHeaderDiv,
            resizeId;

        if (scroll.siblings('.floated-header').length !== 0) {
            floatedHeaderDiv = scroll.siblings('.floated-header');
        }

        if (!floatedHeaderDiv.hasClass('init')) {
            floatedHeaderDiv.addClass('init');
        } else {
            update = true;
        }

        function setScrollLeft () {
            var floatedTable = floatedHeaderDiv.find('table'),
                scroll = table.closest('.scroll-table'),
                scrollLeft = scroll.scrollLeft();

            if (parseInt(floatedTable.css('left'), 10) !== -scrollLeft) {

                floatedHeaderDiv.find('table').css({
                    left: '-' + scrollLeft + 'px'
                });
            }
        }

        function sizeHeaders () {
            var flThead = floatedHeaderDiv.find('thead'),
                colgroup = floatedHeaderDiv.find('colgroup');

            th = table.find('thead').find('tr:last-child th');

            // floatedHeaderDiv.width(scroll.width() - scrollbarWidth)

            floatedHeaderDiv.height(flThead.height())
                .find('.floated-header__table-wrapper').width(scroll.width() - scrollbarWidth)
                .find('table').width(table.width())
                .height(flThead.height());

            if (!thead.hasClass('d-none')) {
                colgroup.children('col').each(function (index) {
                    $(this).css({
                        'width': $(th[index]).outerWidth() + 'px'
                    });
                });

                td.each(function (index) {
                    $(this).css({
                        'width': $(th[index]).width() + 'px'
                    });
                    // $('div', this).css({
                    //    'width': $(th[index]).width() + 'px'
                    // });
                });
            }

            scroll.css({
                top: flThead.height()
            });

            setTimeout(() => {
                floatedBackground.height(flThead.height());
            }, 1);
        }

        offsetTop = 0;

        floatedHeaderDiv.css({
            top: offsetTop
        });

        thead.removeClass('v-hidden');
        sizeHeaders();
        setScrollLeft();
        thead.addClass('v-hidden');

        if (update === undefined) {
            scroll.scroll(function () {
                setScrollLeft();
            });

            // TODO: get scrolling to work when cursor is on TH.
            // newTable.on('mousewheel DOMMouseScroll', function (e) {
            //     var newEvent = new WheelEvent(e.originalEvent.type, e.originalEvent);

            //     scroll.get(0).dispatchEvent(newEvent);
            // });

            $(window).resize(function () {
                sizeHeaders();
                clearTimeout(resizeId);
                resizeId = setTimeout(sizeHeaders, 500);
            });
        }
    };

    $('body').on('click', function (event) {
        var target = $(event.target);

        if (target.closest('.collapse').length === 0) {
            // collapse column filters
            $('.column-filter').hide();
        }

    });
})();